<script lang="ts">
  import type { MyFitnessStores } from '../stores';
  import XataSummary from './XataSummary.svelte';
  import PrePlanCard from './PrePlanCard.svelte';

  export let myFitness: MyFitnessStores;

</script>

<!-- TODO (hyde): improve this XATA column component -->
<PrePlanCard {myFitness} />
<aside class="w-full shrink-0 space-y-4">
  <div class="px-2 text-xs uppercase tracking-wide text-gray-500">Adaptive Training Advisor</div>
  <section class="rounded-lg border border-border bg-white p-3 shadow-sm hover:shadow space-y-2">
    <XataSummary {myFitness} />
  </section>
</aside>
